import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useLabel } from '@atlas/core';
import { getElementsWithLinksFromText } from '@atlas/ui';

const CheckboxLabel = ({ id, label }) => {
  const translatedLabel = useLabel(label);

  const content = useMemo(
    () =>
      getElementsWithLinksFromText(translatedLabel).map(({ link, text }, index) => {
        if (link) {
          const path = link.startsWith('/') ? `${window.location.origin}${link}` : link;

          return (
            <a
              className="link"
              href={path}
              key={`${link}${index}`}
              rel="noreferrer"
              target="_blank"
            >
              {text}
            </a>
          );
        }

        return (
          <span className="text" key={`${text}${index}`}>
            {text}
          </span>
        );
      }),
    [translatedLabel],
  );

  return (
    <label className="label" htmlFor={id}>
      {content}
    </label>
  );
};

CheckboxLabel.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
};

export default CheckboxLabel;
